import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { ModuleOnFitToTile } from '../_actions/ModuleActions'
import ModuleFitToTile, { Props } from '../_components/ModuleFitToTile'

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onClick: () => dispatch(ModuleOnFitToTile(props.moduleId))
});

export default connect(
	null,
	mapDispatchToProps
)(ModuleFitToTile);